import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { CommonSignalStore } from "src/app/common/signal-stores/common-store/common.store";
import { RoutesConstant } from "src/app/constant/routes-constant";
import { AlertService } from "src/app/services/alert.service";

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const alertService = inject(AlertService);
  const commonStore = inject(CommonSignalStore);

  if (
    !commonStore.loginData() &&
    state.url.split("/")[1] &&
    state.url.split("/")[1] == RoutesConstant.MainPath &&
    !commonStore.platformRoles()?.privileges
  ) {
    alertService.alertDanger("Access Denied!", "Session data not found!");
    router.navigate(["/login"]);
    return false;
  }
  return true;
};
